import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import "./historyCompany.scss"

const HistoryCompany = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className="history-company">
            <div className='history-company__mainContainer'>
                <div className='history-company__section'>
                    <h2 className='content__title-backgroundWhite'>{t('about.history.title')}</h2>
                    <div ref={el => lineRefs.current[0] = el} className="content__title-line" />
                    <h3 className='content__subtitle-backgroundWhite'>{t('about.history.subtitle')}</h3>
                    <p className='content__text-title-backgroundWhite'>
                        {t('about.history.p1')}
                    </p>
                </div>
                <div className='history-company__section'>
                    <p className='content__text-paragrah-backgroundWhite'>
                        {t('about.history.p2')}
                    </p>
                    <p className='content__text-paragrah-backgroundWhite'>
                        {t('about.history.p3')}
                    </p>

                    <p className='content__text-paragrah-backgroundWhite'>
                        {t('about.history.p4')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HistoryCompany